import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    test_get(url){
        return axios.get(`${apiUrl}v2/`+ url)
    },
    test_post(url, data){
        return axios.post(`${apiUrl}v2/` + url,  {params: data })
    },
    get_persons(){
        return axios.get(`${apiUrl}v2/salary/get_persons`)
    },
    get_salaries(){
        return axios.get(`${apiUrl}v2/salary/get_salaries`)
    },
    get_salary_types(){
        return axios.get(`${apiUrl}v2/salary/get_salary_types`)
    },
    get_positions(){
        return axios.get(`${apiUrl}v2/salary/get_positions`)
    },
    get_black_box_selections(data){
        return axios.post(`${apiUrl}v2/salary/get_black_box_selections`,{params: data })
    },
    set_by_black_box(data){
        return axios.post(`${apiUrl}v2/salary/set_distribution_by_black_box`,{params: data })
    },
    calc_salary_amount(data){
        return axios.post(`${apiUrl}v2/salary/calc_salary_amount`,{params: data })
    },
    salary_distribution(data){
        return axios.post(`${apiUrl}v2/salary/salary_distribution`,{params: data })
    },
    set_distribution_by_float_ratio(data){
        return axios.post(`${apiUrl}v2/salary/set_distribution_by_float_ratio`,{params: data })
    },
}
